import React, { useEffect, useState } from "react";

const SaveGraphPresetDialog = ({ open, saving, error, onCancel, onSave }) => {
    const [name, setName] = useState("");

    useEffect(() => {
        if (open) {
            setName("");
        }
    }, [open]);

    if (!open) {
        return null;
    }

    return (
        <div className="graph-page__dialog-backdrop" onMouseDown={onCancel}>
            <div
                className="graph-page__dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="save-preset-title"
                onMouseDown={(event) => event.stopPropagation()}
            >
                <h3 id="save-preset-title">Save New Preset</h3>
                <p>The current tags, colors, axes, visibility, and chart display are saved with this name.</p>
                <div className="graph-page__field">
                    <label htmlFor="graph-preset-name">Preset Name</label>
                    <input
                        id="graph-preset-name"
                        value={name}
                        maxLength={80}
                        autoFocus
                        onChange={(event) => setName(event.target.value)}
                    />
                </div>
                {error && <p className="graph-page__banner is-error" role="alert">{error}</p>}
                <div className="graph-page__actions">
                    <button
                        type="button"
                        className="graph-page__button graph-page__button--primary"
                        disabled={saving}
                        onClick={() => onSave(name)}
                    >
                        {saving ? "Saving…" : "Save preset"}
                    </button>
                    <button type="button" className="graph-page__button" onClick={onCancel} disabled={saving}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaveGraphPresetDialog;
